import { CustomPIXIComponent } from 'react-pixi-fiber'
import BoneMerge from './boneMergeRenderer'

export default CustomPIXIComponent({
  customDisplayObject(props) {
    const displayObject = new BoneMerge()
    displayObject.init(props)
    return displayObject
  },
  customApplyProps(displayObject, oldProps, newProps) {
    this.applyDisplayObjectProps(oldProps, newProps)
    if (newProps.spine !== oldProps.spine) {
      displayObject.setSpine(newProps.spine)
    }
  }
}, 'BoneMerge')
